export default "__VITE_ASSET__bab1fc03__"